import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// AlertDialog for confirming permanent deletion of a site. The
// shadcn AlertDialog is the right primitive here (not the regular
// Dialog) — it's modal, focus-trapping, and announces itself as
// destructive to assistive tech. Extracted from Clients.jsx
// (Feb 2026, iter181).
export function DeleteSiteConfirmDialog({
  open, onOpenChange,
  siteName,
  onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to delete &ldquo;{siteName}&rdquo;?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently remove this site and cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="btn-cancel-delete-site">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700"
            data-testid="btn-confirm-delete-site"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
